// src/features/records/components/SearchBar.js
import { Search, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import styles from './SearchBar.module.css';

const SearchBar = ({
  value,
  onChange,
  placeholder,
  onCompositionStart,
  onCompositionEnd
}) => {
  const { t } = useTranslation();
  const placeholderText = placeholder ?? t('records.shell.search_placeholder');
  const isActive = Boolean(value);

  const handleClear = () => {
    onChange('');
  };

  const handleKeyDown = (event) => {
    if (event.key !== 'Escape') {
      return;
    }

    if (value) {
      event.preventDefault();
      event.stopPropagation();
      onChange('');
      return;
    }

    event.currentTarget.blur();
  };

  return (
    <div className={`${styles.searchWrapper} ${isActive ? styles.searchWrapperActive : ''}`}>
      <Search className={styles.searchIcon} size={20} />
      <input
        type="search"
        className={styles.searchInput}
        placeholder={placeholderText}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={handleKeyDown}
        onCompositionStart={onCompositionStart}
        onCompositionEnd={onCompositionEnd}
        aria-label={t('records.shell.search_input_aria')}
      />
      {value && (
        <button
          className={styles.clearButton}
          onClick={handleClear}
          aria-label={t('records.shell.search_clear_aria')}
          type="button"
        >
          <X size={20} />
        </button>
      )}
    </div>
  );
};

export default SearchBar;
